import { render, staticRenderFns } from "./ExciseExceptionsParams.vue?vue&type=template&id=1239f390&"
import script from "./ExciseExceptionsParams.vue?vue&type=script&lang=js&"
export * from "./ExciseExceptionsParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports